import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.color.white};
`;
export const PromoWrapper = styled.div`
  padding: ${rem(16)} 0 0 ${rem(18)};
  display: flex;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar {
    display: none;
    height: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  &:last-child {
    padding-right: ${rem(18)};
  }
`;
